<!-- src/components/HotRanking.vue -->
<template>
    <div class="hot-ranking">
        <h1>{{ title + subtitle }}</h1>

        <!-- 平台选择器 -->
        <div class="platform-selector">
            <label for="platform">选择平台：</label>
            <a-select id="platform" v-model="selectedPlatform" @change="changePlatform" style="width: 150px;">
                <a-option value="douyin">抖音</a-option>
                <a-option value="weibo">微博</a-option>
                <a-option value="zhihu">知乎</a-option>
                <a-option value="bilibili">哔哩哔哩</a-option>
                <a-option value="baidu">百度</a-option>
                <a-option value="tieba">贴吧</a-option>
                <a-option value="toutiao">头条</a-option>
                <a-option value="juejin">掘金</a-option>
            </a-select>
        </div>

        <!-- 加载指示器 -->
        <div v-if="loading" class="loading">
            <a-spin />
            Loading...
        </div>

        <!-- 错误信息 -->
        <div v-if="error" class="error">
            {{ error }}
        </div>

        <!-- 热榜列表 -->
        <ul v-if="!loading && !error" class="hot-list">
            <li v-for="item in hotData" :key="item.index" class="hot-item">
                <div class="rank">{{ item.index }}</div>
                <div class="details">
                    <a :href="item.url" target="_blank" rel="noopener noreferrer">{{ item.title }}</a>
                    <span class="hot">🔥 {{ formatHot(item.hot) }}</span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import { defineComponent, ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
    name: "HotRanking",
    setup() {
        const store = useStore();
        const selectedPlatform = ref('douyin');

        const hotData = computed(() => store.getters['hotRanking/hotData']);
        const title = computed(() => store.getters['hotRanking/title']);
        const subtitle = computed(() => store.getters['hotRanking/subtitle']);
        const loading = computed(() => store.getters['hotRanking/loading']);
        const error = computed(() => store.getters['hotRanking/error']);

        const fetchHotRanking = (platform) => store.dispatch('hotRanking/fetchHotRanking', platform);

        const changePlatform = () => {
            fetchHotRanking(selectedPlatform.value);
        };

        const formatHot = (hot) => {
            return hot.toLocaleString();
        };

        const onImageError = (event) => {
            event.target.src = 'path/to/placeholder.jpg';
        };

        onMounted(() => {
            fetchHotRanking(selectedPlatform.value);
        });

        return {
            selectedPlatform,
            hotData,
            title,
            subtitle,
            loading,
            error,
            changePlatform,
            formatHot,
            onImageError,
        };
    }
});
</script>

<style scoped>
.hot-ranking {
    padding: 20px;
    max-width: 800px;
    margin: 0 auto;
}

.platform-selector {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.platform-selector label {
    font-weight: bold;
}

.loading {
    font-size: 18px;
    color: #888;
    text-align: center;
    margin-top: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.error {
    color: red;
    font-size: 16px;
    text-align: center;
    margin-top: 50px;
}

.hot-list {
    list-style-type: none;
    padding: 0;
}

.hot-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 15px;
    padding: 10px;
    border-bottom: 1px solid #eee;
}

.rank {
    width: 40px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    margin-right: 15px;
    flex-shrink: 0;
}

.pic img {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 4px;
}

.details {
    flex-grow: 1;
}

.details a {
    font-size: 14px;
    color: #333;
    text-decoration: none;
    display: inline-block;
    word-break: break-word;
}

.details a:hover {
    text-decoration: underline;
}

.hot {
    margin-top: 5px;
    color: #f90;
    font-size: 14px;
    display: block;
}
</style>
